import { queryOptions } from '@tanstack/react-query';
import { HttpService } from '@Services/index';

export interface AuthUserIdentityResponse {
  ssn: string;
  birthDate: string;
  idType: string;
  idNumber: string;
  idGovNumber: string;
  idCountry: string;
  idExpirationDate: string;
}

export const getAuthUserIdentity = async (customerId: string, authorizedUserId: string) => {
  const url = `v4/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/identity`;
  const { data } = await HttpService.get<AuthUserIdentityResponse>(url);
  return data;
};

export const getAuthUserIdentityQueryOptions = (customerId: string, authorizedUserId: string) =>
  queryOptions({
    queryKey: ['authUserIdentity', customerId, authorizedUserId],
    queryFn: () => getAuthUserIdentity(customerId, authorizedUserId),
  });
